export default __webpack_public_path__ + "static/media/invoice-examples.338b77a1.png";